module.exports = __webpack_public_path__ + "static/media/31.8c2e5730.jpg";